export default class Plus {
  constructor(element) {
    this.element = element;
    this.btn = document.querySelector('.js-afficher-plus');

    this.init();
  }

  init() {   
    this.element.addEventListener("click", this.openPlus.bind(this));
  }

  openPlus(){
    let container = this.element.parentElement;

    if(container.classList.contains("active")){
      container.classList.remove("active");
    }
    else{
      container.classList.add("active");
    }
  }
}
